import {useEffect, useState} from 'react'
import { useAuth } from '../context/AuthContext';
import { useParams, Link } from 'react-router-dom';
import Navbar from './Navbar';
import { FaMapMarkerAlt, FaArrowRight, FaArrowLeft, FaPhone } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import './AdminMainPage.css';
import BusinessLogin from './BusinessLogin';

const AdminMainPage = () => {
    const { fetchAdminPublicBusiness, adminPublicData, businessAdminToken } = useAuth();
    const { businessId } = useParams();
    const [openBranch, setOpenBranch] = useState(false);
    const [branchesId, setBranchesId] = useState(null);
    const url = "https://resanio.com/business/public/"
    const [copied, setCopied] = useState(false);
    const [iframeOpen, setIframeOpen] = useState(false);

    const iframeCode = `<iframe src="https://resanio.com/business/public/${businessId}/mainpage/reservationform" width="100%" height="1200px" frameborder="0"></iframe>`;

    const copyToClipboard = () => {
        navigator.clipboard.writeText(iframeCode)
        .then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        })
    }

    const toggleIframeOpen = () => {
        setIframeOpen(true);
    }
    const toggleIframeClose = () => {
        setIframeOpen(false);
    }

    const toggleOpenBranch = (branchId) => {
        setOpenBranch(true);
        setBranchesId(branchId); 
    }
    const toggleCloseBranch = () => {
        setOpenBranch(false);
        setBranchesId(null);
    }

    useEffect(() => {
        if (businessId) {
          fetchAdminPublicBusiness(businessId); 
          
        }
    }, [businessId, fetchAdminPublicBusiness]);


    if (!businessAdminToken) {
        return <div>
            <BusinessLogin />
        </div>
    }

  return (
    <div className='min-height'>
        <Navbar />
       
       <div className='adminmainpage-branches-container'>
            {!openBranch && adminPublicData && adminPublicData.branches && adminPublicData.branches.length > 0 ? (<div>
                 <div className='adminmainpage-header'>
                    <h2>Pobočky</h2>
                    <p>Vyberte si pobočku a seznamte se s našimi službami</p>
                </div>
                <div className='adminmainpage-branches'>
                    {adminPublicData.branches.map((branch) => {
                    return <div className='adminmainpage-branch' key={branch._id} onClick={() => toggleOpenBranch(branch._id)}>
                        <div className='adminmainpage-icons'><FaMapMarkerAlt /><FaArrowRight className='adminmainpage-icon-arrow' /></div>
                        <h3>{branch.name}</h3>
                        <div className='adminmainpage-branch-details'>
                            <p className='adminmainpage-branch-city'>{branch.city}</p>
                            <p className='adminmainpage-branch-address'>{branch.street} {branch.houseNumber}, {branch.city} {branch.postalCode} {branch.country}</p>
                        </div>
                    </div>
                })}
                </div>
            </div>) : (
                openBranch ? (
                    <div />
                ) : (
                    <p>Žádné pobočky nebyly nalezeny.</p>
                )
            )
            }
       </div>
       <div >
            {
            openBranch && <div>
                <button className="adminmainpage-back-button" onClick={() => toggleCloseBranch()}><FaArrowLeft size={13}/> Zpět na pobočky</button>
                { adminPublicData.branches && <div>
                    {
                        adminPublicData.branches.filter((branch) => {
                            return branch._id === branchesId;
                        }).map((branch) => {
                            return <div className='adminmainpage-header' key={branch._id}>
                                <h2>{branch.name}</h2>
                                <p className='adminmainpage-header-city'>{branch.city}</p>
                                <p className='adminmainpage-business-address'>{branch.street} {branch.houseNumber}, {branch.city} {branch.postalCode}, {branch.country}</p>
                                {branch.businesses && branch.businesses.length > 0 ? (
                                    <div className='adminmainpage-branch-details-container'>
                                    {branch.businesses.map((business) => {
                                        return <div className='adminmainpage-business' key={business._id}>              
                                            <h3>{business.owner && business.owner}</h3>
                                            <h4>{business.businessType && business.businessType}</h4>
                                            <p className='adminmainpage-branch-contact'><IoIosMail className='adminmainpage-branch-contact-icon' size={19} /> {business.email && business.email}</p>
                                            <p className='adminmainpage-branch-contact'><FaPhone className='adminmainpage-branch-contact-icon' size={12}/> {business.phone && business.phone}</p>
                                            <div className='adminmainpage-links'>
                                                <Link to={`${url}${business._id}`} target="_blank">Profil</Link>
                                                <Link to={`${url}${business._id}/reservation`} target="_blank">Rezervace</Link>
                                            </div>
                                        </div>
                                    })
                                    }
                                    </div>
                                ) : (
                                    <p>Nenalezen žádný profil firmy pro tuto pobočku.</p>
                                )}
                            </div>
                        })
                    }
                </div>
                }
            </div>
            }            
       </div>
       {!openBranch && <div className='adminmainpage-links '>
        { iframeOpen  ? 
         <button className='adminmainpage-copy-button' onClick={toggleIframeClose}>Zavřít</button> :
         <button className='adminmainpage-copy-button' onClick={toggleIframeOpen}>Kód na vložení do stránky</button>
       }  
       </div>}
       
       {iframeOpen && !openBranch && <div className='adminmainpage-links'>
        <h3 >Rychlé vložení do svých stránek</h3>
        <p>Pro vložení našeho rezervačního systému do svých stránek použijte následující kód:</p>
      
        <pre style={{ background: "#f5f5f5", padding: "10px", borderRadius: "6px" }}>
            <code>{iframeCode}</code>
        </pre>

        <button 
            onClick={copyToClipboard} 
            className={`adminmainpage-copy-button ${copied ? "copied" : ""}`}
        >
            {copied ? "Zkopírováno!" : "Zkopírovat"}
        </button>
       </div>}
    </div>
  )
}

export default AdminMainPage